export const CALENDAR_SETTINGS_FORM_SKELETON_SWITCH_ROWS_LENGTH = 6
